import {
    FiGrid,
    FiShoppingBag,
    FiUsers,
    FiUser,
    FiCompass,
    FiGift,
    FiList,
    FiSettings,
} from "react-icons/fi";
import { BsBusFront, BsFillChatDotsFill } from "react-icons/bs";
import language from "../../language";
import { IoWallet } from "react-icons/io5";
/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
        !sessionStorage.getItem("language")
        ? true
        : false;

const sidebar = [
    {
        path: "/user/profile", // the url
        icon: FiGrid, // icon
        name: `${languageSelectedEnglish ? "Profile" : language.dashboard}`,
    },
    {
        path: "/user/mybookings",
        icon: BsBusFront,
        name: `${languageSelectedEnglish ? "My Bookings" : language.buses}`,
    },
    {
        path: "/user/transactionsandhistory",
        icon: IoWallet,
        name: `${languageSelectedEnglish ? "My Transactions History & Wallet" : language.buses}`,
    },
];

export default sidebar;
